import { OnboardingSummary } from '@/components/onboarding-summary';
import { Text } from '@/components/text';
import { Badge } from '@/components/ui/badge';
import { View } from '@/components/ui/tw-wrappers';
import { SCREEN_MAX_WIDTH } from '@/constants/layout';
import { Country } from '@/types/country';
import { TransferPair } from '@/types/transfer-pair';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

interface ComparisonResultsHeaderProps {
  countries: Country[];
  countriesLoading: boolean;
  data?: TransferPair | null;
}

export function ComparisonResultsHeader({
  countries,
  countriesLoading,
  data,
}: ComparisonResultsHeaderProps) {
  const { t } = useTranslation();

  return (
    <View style={styles.container}>
      <View style={styles.innerContainer}>
        <View className='w-full pb-5 gap-3 items-center md:items-start'>
          <Badge label={t('home.scenarios.resultsBadge', 'SIMULATION COMPLETED')} color='#017f32' />
          <Text type='title' className='text-center md:text-left'>
            {t('home.scenarios.resultsTitle')}
          </Text>
          <Text style={styles.descriptionText} className='text-center md:text-left'>
            {t('home.scenarios.resultsSubtitle')}
          </Text>
          <Text style={styles.descriptionText} className='text-center md:text-left'>
            {t('home.scenarios.resultsDescription')}
          </Text>
        </View>
        <OnboardingSummary
          countries={countries}
          countriesLoading={countriesLoading}
          exchangeRate={data?.exchangeRate}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    // backgroundColor: '#ffffff',
  },
  innerContainer: {
    maxWidth: SCREEN_MAX_WIDTH,
    alignSelf: 'center',
    width: '100%',
    paddingHorizontal: 16,
    marginTop: 50,
    gap: 34, // Matches the gap from the parent View in compare.tsx
    justifyContent: 'center',
    zIndex: 10,
    paddingBottom: 34,
  },
  descriptionText: {
    color: '#666',
  },
});
